mergeFalseFn